export const CREATE_BOOKING_QUERY = 'create';
export const CREATE_BOOKING_VALUE = 'booking';
export const CREATE_SERIES_VALUE = 'series';
export const CREATE_BOOKING_HREF = `/schedule?${CREATE_BOOKING_QUERY}=${CREATE_BOOKING_VALUE}`;
export const CREATE_SERIES_HREF = `/schedule?${CREATE_BOOKING_QUERY}=${CREATE_SERIES_VALUE}`;

export const CREATE_BOOKING_PERMISSION = 'booking:create_for_others';
